import { defineAction, object } from '~/prix'
import { spaceForPoint } from '~/prix/types/presets/space'
import operationalMonitoringAction from './operationalMonitoring.action.json' with { type: 'json' }

const operationalMonitoringDefinition = defineAction({
  ...operationalMonitoringAction,
  userActivityLog: true,
  operation: 'read' as const,
  input: object({
    space: spaceForPoint().isOptional(),
  }),
  output: object({}),
})

export default operationalMonitoringDefinition
